import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from './locales/en/common.json'
import arCommon from './locales/ar/common.json'

// Configure i18next with React integration, language detection, and RTL support
const resources = {
  en: {
    common: enCommon,
  },
  ar: {
    common: arCommon,
  },
}

i18n
  .use(LanguageDetector) // Detect language from browser/localStorage
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    debug: import.meta.env.VITE_ENABLE_DEBUG === 'true',

    // Namespace configuration
    defaultNS: 'common',
    ns: ['common'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

// Helper to check if current language is RTL
export const isRTL = (lng: string = i18n.language): boolean => {
  return ['ar', 'he', 'fa', 'ur'].includes(lng)
}

// Helper to get text direction
export const getDirection = (lng: string = i18n.language): 'rtl' | 'ltr' => {
  return isRTL(lng) ? 'rtl' : 'ltr'
}

export default i18n
